import { BillingDashboard, ClaimReviewScreen, useProfile } from '@hb/react-web'
import { useParams } from 'react-router-dom'

export const BillingDashboardView = () => {
  const { encounterId } = useParams<{ encounterId?: string }>()
  const { patientRef } = useProfile()
  if (encounterId) return <ClaimReviewScreen patientRef={patientRef} encounterId={encounterId} />
  return <BillingDashboard />
}
